import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IStudentOfConcernInterview } from '../models/studentOfConcernInterview';

@Injectable({
  providedIn: 'root'
})
export class StudentOfConcernInterviewService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getStudentOfConcernInterviewByCaseId(caseId: string): Observable<IStudentOfConcernInterview> {
        const url = environment.apiBaseUrl + endpoints.getStudentOfConcernInterviewByCaseId.replace(':caseId', caseId);
        return this.http.get<IStudentOfConcernInterview>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateStudentOfConcernInterview(data: IStudentOfConcernInterview): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateStudentOfConcernInterview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}